// Picks white or dark ink for text sitting on a photograph.
// Samples the average luminance of a region of a small rendition (data-src) and sets
// data-ink="light" (white text) or "dark" (black text) on itself. Region: data-region="bottom-left" (default)
// samples the lower-left 45% x 40% where overlay copy sits. Falls back to light ink if sampling fails.
class SAutoInk extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ink && this.dataset.ink !== 'auto') return;
    const src = this.dataset.src;
    if (!src) return;
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.decoding = 'async';
    image.onload = () => {
      try {
        const width = image.naturalWidth;
        const height = image.naturalHeight;
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const context = canvas.getContext('2d', { willReadFrequently: true });
        context.drawImage(image, 0, 0, width, height);
        const regionWidth = Math.max(1, Math.round(width * 0.45));
        const regionHeight = Math.max(1, Math.round(height * 0.4));
        const { data } = context.getImageData(0, height - regionHeight, regionWidth, regionHeight);
        let total = 0;
        for (let i = 0; i < data.length; i += 4) {
          total += 0.2126 * data[i] + 0.7152 * data[i + 1] + 0.0722 * data[i + 2];
        }
        const luminance = total / (data.length / 4) / 255;
        this.dataset.ink = luminance < 0.58 ? 'light' : 'dark';
      } catch {
        this.dataset.ink = 'light';
      }
    };
    image.onerror = () => { this.dataset.ink = 'light'; };
    image.src = src;
  }
}

if (!customElements.get('s-auto-ink')) customElements.define('s-auto-ink', SAutoInk);
